import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import CreativePortfolio from '../../components/creative-portfolio'
import Footer from '../../components/footer'

import bg from '../../assets/images/bg.jpg'

export default function PortfolioCreativeSix() {
  return (
    <>
      <Navbar/> 

      <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg})`, backgroundPosition:'center'}}>
        <div className="bg-overlay bg-overlay-white"></div>
        <div className="container">
            <div className="row mt-5 text-center align-items-center">
                <div className="col-sm-6">
                    <div className="text-sm-start">
                        <div className="page-next-level">
                            <h4 className="title">Portfolio</h4>
                            <p className="text-muted mb-0">All work and portfolio posts are here,</p>                                        
                        </div>
                    </div>
                </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                            <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Work</Link></li>
                            <li className="list-inline-item">
                                <span className="text-uppercase text-primary fw-bold">Work</span> 
                            </li> 
                        </ul>
                    </div>
                </div>
            </div>
        </div> 
      </section>
      <ShapeTwo/>
      <section className="section">
        <div className="container-fluid">
            <CreativePortfolio grid="col-lg-12" col="col-lg-2 col-md-4 col-sm-6 col-12 spacing picture-item" row="row mt-4"/>
            <div className="row text-center mt-4 pt-2">
                <div className="col-12">
                    <ul className="pagination justify-content-center mb-0 list-unstyled">
                        <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border"> Prev</Link></li>
                        <li className="active"><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">1</Link></li>
                        <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">2</Link></li>
                        <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">3</Link></li>
                        <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">4</Link></li>
                        <li><Link to="#" className="pe-3 ps-3 pt-2 pb-2 border">Next </Link></li>
                    </ul>
                </div>
            </div>
        </div>
      </section>
      <Shape/>
      <Footer/>
    </>
  )
}
